module.exports = __webpack_public_path__ + "static/media/black.a37615db.ogg";